import { FunctionInterface } from '../../../../model/function.model';

/**
 * The toolbox's two function categories: Bastion flows in their own, so a builder tells their flows from platform
 * functions at a glance; everything else in API, as before.
 */
export function fillFunctionSlots(toolbox: string, functions: FunctionInterface[]): string {
  const blocks = (list: FunctionInterface[]) => list.map((f) => `<block type="${f.name}_api_functions"></block>`).join('\n');
  return toolbox
    .replace('$REPLACE', blocks(functions.filter((f) => f.type !== 'BASTION')))
    .replace('$BASTION_FLOWS', blocks(functions.filter((f) => f.type === 'BASTION')));
}
